import Grid from '@mui/material/Grid';

import { FormSelectDynamic } from '../../components/hook-form/form-select.dynamic.component';
import { workOrdersApiKeyStore } from '../../api/workorders-api-key-store';
import { FormInput } from '../../components/hook-form/form-input.component';

export const InspectionForm = () => {
  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormSelectDynamic
          name="workOrderStatusID"
          label="Inspection Status"
          required
          getQueryKeyConfig={() => workOrdersApiKeyStore.getWorkOrderStatus('inspection')}
          optionsValueKey="workOrderStatusID"
          optionsLabelKeys={['workOrderStatus']}
        />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput type="number" label="Worked Hours" name="workedHours" />
      </Grid>
    </Grid>
  );
};
